
import React, { Component } from 'react';

import MenuBar from '../components/MenuBar/MenuBar'

class CommingSoon extends Component {

    render() {

        return (
            <div >
                <MenuBar />
                <h1><br/><br/><br/><br/><br/>COMMING SOON ^^</h1>
            </div>
           
        );
    }
}
export default CommingSoon;


// WEBPACK FOOTER //
// ./src/app/view/containers/CommingSoon.js